module.exports = __webpack_public_path__ + "img/UTJORD-6.004d3a1d.jpg";